import { Suspense } from 'react';
import { cms, flattenEntry } from '@/cms';
import { LimitPagination, TopicEntry } from '@/cms/types/entry';

import { Feed } from './Feed';

type ArticlesFeedProps = {
  articles: any[];
  pagination: LimitPagination;
  initialTopicSlug?: string;
  paginationLabel: string;
  hasFilters: boolean;
  hasSearch: boolean;
  featuredTopics: TopicEntry[];
  currentPage: number;
};

export const ARTICLES_PER_PAGE = 18;

export async function ArticlesFeed({
  articles,
  pagination,
  initialTopicSlug,
  hasFilters,
  hasSearch,
  paginationLabel,
  featuredTopics,
  currentPage,
}: ArticlesFeedProps) {
  const allTopics = await cms.getAllTopicLabels();

  return (
    <Suspense>
      <div data-tracker-section='blog-articles'>
        <Feed
          initialArticles={{ data: articles, pagination }}
          allTopics={allTopics?.data?.map(flattenEntry)}
          featuredTopics={featuredTopics}
          initialTopicSlug={initialTopicSlug}
          paginationLabel={paginationLabel}
          hasFilters={hasFilters}
          hasSearch={hasSearch}
          currentPageNumber={currentPage}
        />
      </div>
    </Suspense>
  );
}
